
import AppHeader from '@/components/Header.vue'
import {
  defineComponent,
  computed,
  ref,
  getCurrentInstance,
  onMounted,
  reactive,
  onBeforeUnmount,
} from 'vue'
import { Icon, PullRefresh, Toast, Dialog } from 'vant'
import { useStore } from 'vuex'
import {
  getRepairDetail,
  confirmRepairOrder,
  payRepairOrder,
  searchPayStatus,
} from '@/apis/service'
import { CacheSelectRepairOrderInfoKey } from '@/config/insurance'
import { useAppPay } from '@/compositions/usePay'
import appHost from '@/utils/app'
import wx from 'weixin-js-sdk'
export default defineComponent({
  name: 'RepairOrder',
  components: {
    AppHeader,
    vanPullRefresh: PullRefresh,
    vanIcon: Icon,
  },
  setup() {
    const loading = ref(false)
    const { proxy } = getCurrentInstance()
    const searchInterval = ref(0)
    const { compatibleWechatAndCmdPay, judgeCanUseMiniProgramPay } = useAppPay()
    const repairBaseMessage = reactive({
      repair_status: '', // 维修单状态
      repair_status_text: '', // 维修单状态说明
      repair_sn: '', // 维修单号
      repair_warehouse_name: '', // 维修网点名称
      service_type: '', // 维修单类型
      service_type_text: '', // 维修单类型说明
      pay_type: '', // 支付类型
      pay_type_text: '', // 支付类型
      pay_status: 0, // 支付单状态
      pay_status_text: '', // 支付单状态说明
      pay_amount: 0, // 应支付费用
      mate_amount: 0, // 配件费用
      hourly_amount: 0, // 工时费费用
      discount_amount: 0, // 抵扣金额
      current_amount: 0, // 使用保险后剩余额度
      mateList: [], // 维修配件列表
    })
    let invoiceInfo = ''
    const btnStatus = reactive({
      showRepairbtn: false,
      showPaybtn: false,
      showApplyInovice: false,
    })
    const store = useStore() // vuestore
    const pagePaddingTop = computed(() => store.getters.pagePaddingTop)
    const onRefresh = async () => {
      await handleGetRepairDetail()
      clearInterval(searchInterval.value)
      loading.value = false
    }
    const handleGetRepairDetail = async () => {
      let param = {
        guid: proxy.$route.params.guid,
      }
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let result: any = await getRepairDetail(param)
        repairBaseMessage.repair_status = result.repair_status
        repairBaseMessage.repair_status_text = result.repair_status_text
        repairBaseMessage.repair_warehouse_name = result.repair_warehouse_name
        repairBaseMessage.repair_sn = result.repair_sn
        if (
          result.pay_order_info &&
          typeof result.pay_order_info == 'object' &&
          Object.keys(result.pay_order_info).length >= 1
        ) {
          repairBaseMessage.pay_type = result.pay_order_info.pay_type
          repairBaseMessage.pay_type_text = result.pay_order_info.pay_type_text
          repairBaseMessage.service_type = result.pay_order_info.service_type
          repairBaseMessage.service_type_text = result.pay_order_info.service_type_text
          repairBaseMessage.mateList = result.pay_order_info.mateList
          repairBaseMessage.mate_amount = result.pay_order_info.mate_amount
          repairBaseMessage.hourly_amount = result.pay_order_info.hourly_amount
          repairBaseMessage.discount_amount = result.pay_order_info.discount_amount
          repairBaseMessage.current_amount = result.pay_order_info.current_amount
          repairBaseMessage.pay_amount = result.pay_order_info.pay_amount
          repairBaseMessage.pay_status = result.pay_order_info.pay_status
          repairBaseMessage.pay_status_text = result.pay_order_info.pay_status_text
        }
        // 按钮状态
        btnStatus.showRepairbtn = result.action.confirmPayOrder
        btnStatus.showPaybtn = result.action.pay
        btnStatus.showApplyInovice = result.action.invoice_apply
        invoiceInfo = JSON.stringify(result.invoice_info)
        toast.clear()
      } catch (error: any) {
        let message = error && error.message ? error.message : '操作失败'
        toast.clear()
        Toast(message)
      }
    }
    const handleConfirm = async () => {
      Dialog.confirm({
        message: '确认维修',
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        className: 'repair-dialog',
        width: 304,
      })
        .then(async () => {
          let param = {
            guid: proxy.$route.params.guid,
            is_agree: 1,
          }
          let toast = Toast({
            type: 'loading',
            message: '加载中...',
            forbidClick: true,
            duration: 0,
          })
          try {
            let result = await confirmRepairOrder(param)
            toast.clear()
            Dialog.close()
            // 刷新数据
            handleGetRepairDetail()
          } catch (error: any) {
            Dialog.close()
            let message = error && error.message ? error.message : '操作失败'
            toast.clear()
            Toast(message)
          }
        })
        .catch(() => {
          Dialog.close()
        })
    }
    // 检测情况
    const handleCheckDetail = () => {
      proxy.$router.push({ path: `/checkdetail/${proxy.$route.params.guid}` })
    }
    // 申请发票
    const handleApplyInvoice = () => {
      const invoiceInfoData = JSON.parse(invoiceInfo)
      if (invoiceInfoData.is_excess) {
        // 超过额度
        Dialog.alert({
          title: '',
          message: '开票金额过大，请联系直营服务站或极飞客服线下申请发票！',
          confirmButtonColor: '#39b54a',
        }).then(() => {
          // on close
        })
        return
      }
      const cacheKey = CacheSelectRepairOrderInfoKey + proxy.$route.params.guid
      sessionStorage.setItem(cacheKey, invoiceInfo)
      proxy.$router.push({
        name: 'insurance-repair-invoice-apply',
        query: {
          cacheKey,
        },
      })
    }
    // 发起微信支付
    const handlePayRepairOrder = async () => {
      // 发起支付
      clearInterval(searchInterval.value)
      let param = {
        guid: proxy.$route.params.guid,
        from: 'app',
        callback_page_url: '',
        payment_platform: '',
      }

      if (store.getters.isMiniProgram) {
        param.from = 'applets'
        param.callback_page_url = window.location.origin + getCbPageUrl()
        console.log('KL', 'handlePayRepairOrder', param)
      } else {
        // 非小程序的时候, 兼容旧版本app支付将使用原来的微信支付
        const canUseCmbPay = await judgeCanUseMiniProgramPay()
        console.log('canUseCmbPay', canUseCmbPay)
        param.payment_platform = canUseCmbPay ? 'merchants_bank' : 'wechat'
      }
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        const result: any = await payRepairOrder(param)
        toast.clear()
        if (result.pay_type == '线上支付') {
          if (result.need_wechat_pay && param.from === 'applets') {
            wx.miniProgram.navigateTo({
              url: '/pages/user/pay?guid=' + result.pay_order_no,
            })
          } else if (result.need_wechat_pay) {
            //appHost.onPay(result.pay_order_no)
            compatibleWechatAndCmdPay(result.pay_order_no)
            handleSearchPayStatus(result.pay_order_no)
          } else {
            handleGetRepairDetail()
          }
          return
        }
        if (result.pay_type == '线下支付') {
          if (result.need_wechat_pay) {
            Toast('错误，线下支付不需要微信支付！')
          } else {
            handleGetRepairDetail()
          }
        }
      } catch (error: any) {
        let message = error && error.message ? error.message : '支付失败，请重试'
        toast.clear()
        Toast(message)
      }
    }
    // 支付成功页面
    const getCbPageUrl = (): string => {
      return `/afterpay/1/${repairBaseMessage.repair_sn}/${proxy.$route.params.guid}/${repairBaseMessage.pay_amount}`
    }
    const handleSearchPayStatus = (pay_order_no: string) => {
      let toast = Toast({
        type: 'loading',
        message: '支付结果查询中',
        forbidClick: false,
        duration: 0,
      })
      let i = 0
      let searching = false
      searchInterval.value = setInterval(async () => {
        // 如果查询时间超过1分钟 那么停止查询并提示
        if (i >= 12) {
          clearInterval(searchInterval.value)
          toast.clear()
          Dialog.confirm({
            title: '查询结果失败',
            message: `支付订单号${pay_order_no}，请尝试继续校验，如需帮助请联系客服：400-780-3131`,
            confirmButtonText: '重新查询',
            cancelButtonText: '取消查询',
            className: 'reserve-dialog',
            width: 304,
          })
            .then(async () => {
              try {
                handleSearchPayStatus(pay_order_no)
              } catch (error: any) {
                Dialog.close()
              }
            })
            .catch(() => {
              Dialog.close()
            })
        }
        if (searching) {
          return
        }
        let result = await searchPayStatus({ guid: proxy.$route.params.guid })
        if (result) {
          toast.clear()
          // 跳转到支付成功页面
          clearInterval(searchInterval.value)
          proxy.$router.replace({ path: getCbPageUrl(), query: proxy.$route.query })
        }
        searching = false
        i++
      }, 5000)
    }
    const handleClikBack = () => {
      if (proxy.$route.query.from && proxy.$route.query.from == 'app') {
        appHost.goAppBack()
        return
      }
      proxy.$router.back()
    }
    onMounted(() => {
      handleGetRepairDetail()
    })
    onBeforeUnmount(() => {
      clearInterval(searchInterval.value)
    })
    return {
      loading,
      repairBaseMessage,
      btnStatus,
      pagePaddingTop,
      onRefresh,
      handleConfirm,
      handleCheckDetail,
      handlePayRepairOrder,
      handleClikBack,
      handleApplyInvoice,
    }
  },
})
